module.exports = __webpack_public_path__ + "static/img/6.4005e0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/zh/6.png
// module id = aQhz
// module chunks = 0